import React from "react";
import {
  Dialog,
  DialogContent,
  DialogActions,
  Button,
  Typography,
  Box,
} from "@mui/material";
import PersonOffOutlinedIcon from "@mui/icons-material/PersonOffOutlined";
import { VM_Colors } from "../Styles/VMStyles";

/**
 * Shown when subscription status API returns user not found (invalid/stale session).
 * Cannot dismiss via backdrop or Escape — only the primary action.
 */
function UserNotFoundDialog({ open, message, onConfirm }) {
  const bodyMessage =
    message && message.toLowerCase() !== "user not found"
      ? message
      : "The account linked to this session could not be found. Please sign in again to continue.";

  return (
    <Dialog
      open={open}
      onClose={(_, reason) => {
        if (reason === "backdropClick" || reason === "escapeKeyDown") return;
      }}
      aria-labelledby="user-not-found-dialog-title"
      aria-describedby="user-not-found-dialog-description"
      disableEscapeKeyDown
      maxWidth="xs"
      fullWidth
      PaperProps={{
        sx: {
          borderRadius: 3,
          overflow: "hidden",
          boxShadow: "0 12px 40px rgba(30, 58, 138, 0.18)",
        },
      }}
    >
      <DialogContent sx={{ px: 3, pt: 4, pb: 2, textAlign: "center" }}>
        <Box
          sx={{
            width: 72,
            height: 72,
            borderRadius: "50%",
            mx: "auto",
            mb: 2.5,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            bgcolor: VM_Colors.error_transparent,
          }}
        >
          <PersonOffOutlinedIcon
            sx={{ fontSize: 40, color: VM_Colors.primary }}
            aria-hidden
          />
        </Box>

        <Typography
          id="user-not-found-dialog-title"
          variant="h6"
          component="h2"
          fontWeight={700}
          color={VM_Colors.primary}
          gutterBottom
        >
          Account not found
        </Typography>

        <Typography
          id="user-not-found-dialog-description"
          variant="body2"
          color="text.secondary"
          sx={{ lineHeight: 1.6, maxWidth: 320, mx: "auto" }}
        >
          {bodyMessage}
        </Typography>
      </DialogContent>

      <DialogActions sx={{ px: 3, pb: 3, pt: 0 }}>
        <Button
          fullWidth
          variant="contained"
          color="primary"
          onClick={onConfirm}
          autoFocus
          sx={{
            py: 1.25,
            borderRadius: 2,
            fontSize: "1rem",
          }}
        >
          Go to sign in
        </Button>
      </DialogActions>
    </Dialog>
  );
}

export default UserNotFoundDialog;
